//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AngledWallSolution",1,0],[0,"AutoInferWall",1,0],[1,"CornerClearance",0,"Expression",0],[0,"DeselectedFaces",1,"ScCollector",0],[1,"Diameter",0,"Expression",0],[0,"FloorFaces",1,"ScCollector",0],[1,"FluteLength",0,"Expression",0],[1,"LowerRadius",0,"Expression",0],[1,"NeckDiameter",0,"Expression",0],[0,"ToolType",1,0],[1,"UpperRadius",0,"Expression",0],[0,"WallFaces",1,"ScCollector",0]],[],[]];
SPLM.Features.BlendPocketBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BlendPocketBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BlendPocketBuilder.ToolTypes = Object.freeze({
    "Unknown" : "Unknown", "EndMill" : "EndMill", "TCutter" : "TCutter", "SphericalMill" : "SphericalMill"});

SPLM.Features.BlendPocketBuilder.AngledWallSolutions = Object.freeze({
    "Unknown" : "Unknown", "SwarfCutWall" : "SwarfCutWall", "CutFloorAndSwarfCutWall" : "CutFloorAndSwarfCutWall", "CutFloor" : "CutFloor", "SwarfCutWallAndFloor" : "SwarfCutWallAndFloor"});

export default SPLM;